import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import isEqual from 'lodash/isEqual';
import isNull from 'lodash/isNull';
import isObject from 'lodash/isObject';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getProductByProductKey } from '@yme/api';
import { QueryParams } from '@yme/common/constants';
import { getRootPath } from '@yme/components/CheckoutForm/PaymentSteps/selectors';
import { setSelectedModelCookieFromUrl } from '@yme/pages/components/ProductsGrid/helpers';
import { COOKIE_HYPERDRIVE_SELECTED_UNIT } from '@yme/pdp-components/ProductCard/CardAccessories/constants';
import { getQueryParamByName } from '@yme/utils/common';
import { ACCESSORIES_COMPATIBILITY_KEY } from '@yme/utils/constants';
import { getCurrentProductParameters } from './components/CompatibilityPanel/helpers';
export function useCompatibleProduct({ endpoint, isEnabled, }) {
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [compatibleProduct, setCompatibleProduct] = useState(null);
    const [productDataByKey, setProductDataByKey] = useState(null);
    const { search } = useLocation();
    const languageRootPath = useSelector(getRootPath);
    // Setter storage params
    useEffect(() => {
        if (!isEnabled) {
            return;
        }
        const currentProduct = localStorage.getItem(ACCESSORIES_COMPATIBILITY_KEY) || null;
        if (!isNull(compatibleProduct) && !isEqual(compatibleProduct, currentProduct)) {
            localStorage.setItem(ACCESSORIES_COMPATIBILITY_KEY, JSON.stringify(compatibleProduct));
        }
        if (compatibleProduct && isObject(compatibleProduct)) {
            setIsCheckboxChecked(Boolean(compatibleProduct?.isCompatibleChecked));
        }
    }, [compatibleProduct, productDataByKey, isEnabled]);
    // Getter storage params
    useEffect(() => {
        if (!isEnabled) {
            return;
        }
        const currentProduct = localStorage.getItem(ACCESSORIES_COMPATIBILITY_KEY) || null;
        if (productDataByKey) {
            if (!('isCompatibleChecked' in productDataByKey)) {
                productDataByKey.isCompatibleChecked = true;
                setIsCheckboxChecked(true);
            }
            setCompatibleProduct(productDataByKey);
        }
        else if (currentProduct) {
            const result = JSON.parse(currentProduct);
            if (typeof result === 'object' && result !== null) {
                if (!('isCompatibleChecked' in result)) {
                    result.isCompatibleChecked = true;
                    setIsCheckboxChecked(true);
                }
            }
            setCompatibleProduct(result);
        }
        else {
            setCompatibleProduct(null);
        }
    }, [productDataByKey, isEnabled]);
    // Get productData by productKey (through request)
    useEffect(() => {
        const compatibleProductKeyByParam = getQueryParamByName(search, QueryParams.PRODUCT) || null;
        const CompatibilityProductKeyByCookie = Cookies.get(COOKIE_HYPERDRIVE_SELECTED_UNIT);
        setSelectedModelCookieFromUrl({
            compatibleProductKeyByParam,
            CompatibilityProductKeyByCookie,
            languageRootPath,
        });
        if (compatibleProductKeyByParam) {
            (async () => {
                try {
                    const productData = await getProductByProductKey({
                        endpoint,
                        keyParam: compatibleProductKeyByParam,
                    });
                    setProductDataByKey(getCurrentProductParameters(productData[0]));
                }
                catch (err) { }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endpoint, languageRootPath]);
    return {
        compatibleProduct,
        setCompatibleProduct,
        isCheckboxChecked,
        setIsCheckboxChecked,
    };
}
